__turbopack_context__.v({
  "actions": "GZMo2q_actions",
  "filters": "GZMo2q_filters",
  "participantsSection": "GZMo2q_participantsSection",
  "sheetContent": "GZMo2q_sheetContent",
  "totalPrice": "GZMo2q_totalPrice",
  "totalPriceLabel": "GZMo2q_totalPriceLabel",
});
